<template>
  <v-container id="login" class="justify-center mt-8" tag="section">
    <v-row justify="center" style="margin-bottom: 20px">
      <div style="width: 100%; max-width: 260px">
        <v-img contain :src="require(`@/assets/logo.png`)" />
      </div>
    </v-row>
    <v-row justify="center">
      <h2>Administration</h2>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  name: 'HomePage',

  computed: {
    ...mapGetters({
      account: 'account'
    })
  },
  watch: {
    account: {
      handler () {
        if (this.account) {
          this.$router.push('/app/videos')
        }
      },
      immediate: true
    }
  }
})
</script>
